import defaultConfig from './default'
import dev from './dev'
import devStage from './dev-stage'
import devProd from './dev-prod'
import stage from './stage'
import prod from './prod'

const configStack = {
    dev,
    stage,
    prod,
    devStage,
    devProd
}

const env = process.env.REACT_APP_ENV || 'prod'

if(!process.env.REACT_APP_ENV) {
    console.log('No env found at process.env.REACT_APP_ENV:', process.env.REACT_APP_ENV)
}
console.log('ENV Set:', env)

const config = Object.assign({}, defaultConfig, configStack[env])

export default config